@if (fileInfo) {
  @if (fileInfo.viewerType === 'simple') {
    <app-simple-document-viewer
      [documentUrl]="fileInfo.documentUrl"
      [boxFile]="fileInfo.boxFile"
      [fileMetadata]="fileInfo.fileMetadata"
      [commentaire]="fileInfo.commentaire"
    (close)="closeDocumentViewer()"></app-simple-document-viewer>
  }
  @if (fileInfo.viewerType === 'appended-file') {
    <app-appended-document-viewer
      [fichierOperation]="fileInfo.fichierOperation!"
      (close)="closeAppendedDocumentViewer($event)"
    (remove)="removeFichierOperation($event)"></app-appended-document-viewer>
  }
  @if (fileInfo.viewerType === 'operation') {
    <lib-operation-document-viewer
      [fichierOperation]="fileInfo.fichierOperation!"
    (close)="closeDocumentViewer()"></lib-operation-document-viewer>
  }
  @if (fileInfo.viewerType === 'custom') {
    <ng-template [cdkPortalOutlet]="fileInfo.customPortal!"></ng-template>
  }
}
